import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup} from '@angular/forms';

enum Controls {
  DischargeType = 'dischargeType',
}

export enum DischargeType {
  TransferToSubAcute = 'Transfer to Sub-Acute',
  ContinuanceOfCare = 'Continuance of Care',
  PrivateHomeNursing = 'Private Home Nursing',
  FinalDischarge = 'Final Discharge'
}

enum RadioGroupName {
  DischargeRadioGroup = 'dischargeRadioGroup',
}

@Component({
  selector: 'app-case-discharge-dialog',
  templateUrl: './case-discharge-dialog.component.html',
  styleUrls: [
    './case-discharge-dialog.component.scss',
    '../../../../../../styles/global/_dialog-styles.scss',
  ]
})
export class CaseDischargeDialogComponent implements OnInit {
  readonly controls = Controls;
  readonly dischargeType = DischargeType;
  readonly radioGroupName = RadioGroupName;

  formGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CaseDischargeDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  get selectedOption(): string {
    return this.formGroup.controls[Controls.DischargeType].value;
  }

  ngOnInit(): void {
    this.initFormGroup();
  }

  initFormGroup(): void {
    this.formGroup = this.formBuilder.group({
      [this.controls.DischargeType]: [this.dischargeType.TransferToSubAcute]
    });
  }

  onDischargeCaseClick($event: any): void {
    $event.stopPropagation();
    const dischargeOption = this.selectedOption;
    this.dialogRef.close(dischargeOption);
  }

  onCancelDialogClick() {
    this.dialogRef.close(null);
  }

}
